import { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { ListChecks, RefreshCcw } from "lucide-react";

export default function PromoterMyLogs() {
  const [items, setItems] = useState([]);
  const load = useCallback(() => api.get(`/promoter/logs`).then(({ data }) => setItems(data.items || [])), []);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="promoter-my-logs-page">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl font-semibold flex items-center gap-2">
          <ListChecks className="w-5 h-5" /> My Submitted Logs
        </h1>
        <div className="flex items-center gap-2">
          <button onClick={load} className="px-3 py-1.5 text-sm rounded-lg border border-slate-300 inline-flex items-center gap-1">
            <RefreshCcw className="w-3.5 h-3.5" /> Refresh
          </button>
          <Link to="/promoter/new-log" data-testid="promoter-logs-new"
                 className="px-3 py-1.5 text-sm rounded-lg bg-[#1B4332] text-white">+ New log</Link>
        </div>
      </div>
      <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.map((l) => (
          <article key={l.id} data-testid={`my-log-${l.id}`}
                    className="rounded-xl border border-slate-200 bg-white p-4">
            <div className="text-[11px] uppercase tracking-[0.16em] text-slate-500 font-semibold">
              {(l.contacted_date || l.created_at || "").slice(0, 10)} · {l.business_type}
            </div>
            <div className="font-display text-lg font-semibold mt-0.5">{l.business_name}</div>
            <div className="text-xs text-slate-600 mt-0.5">
              {[l.city, l.province].filter(Boolean).join(", ") || "-"}
            </div>
            <div className="mt-2 text-xs">
              <span className="px-1.5 py-0.5 rounded bg-slate-100 border border-slate-200">{l.result_status}</span>
              {l.contact_name && <span className="ml-2 text-slate-600">{l.contact_name} {l.contact_position ? `(${l.contact_position})` : ""}</span>}
            </div>
            {l.notes && <p className="text-xs text-slate-700 mt-2 line-clamp-3">{l.notes}</p>}
          </article>
        ))}
        {items.length === 0 && <div className="col-span-full text-center text-slate-500 py-10">You have not submitted any logs yet.</div>}
      </div>
    </div>
  );
}
